export enum SftpSettingsListColumns {
  SCHOOL_GROUP = 'School Group',
  SCHOOL = 'School',
  GROUP_LEVEL = 'Group Level',
  IMPORT_SUBJECT = 'Subject',
  AUTOMATIC_IMPORT_ENABLED = 'Enabled',
  ACTIONS = 'Actions'
}
